import { motion } from "framer-motion";
import { fadeUp, viewport } from "../../lib/motion";
import { AppBadges } from "./AppBadges";

export const DownloadCta = () => (
  <section className="bg-slate-50 py-24 md:py-32" data-testid="download-section">
    <div className="mx-auto max-w-8xl px-5 md:px-10">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="relative overflow-hidden rounded-[2.5rem] bg-maraca-teal px-8 py-16 text-center md:px-16 md:py-24"
      >
        <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-white/20 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-maraca-navy/20 blur-2xl" />
        <div className="relative">
          <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-maraca-navy md:text-6xl">
            Baixe o app e peça agora
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg text-maraca-navy/70">
            Comida, mercado e serviços de Maracás na palma da sua mão. Grátis para baixar.
          </p>
          <AppBadges className="mt-8 justify-center" />
        </div>
      </motion.div>
    </div>
  </section>
);
